<article class="m-panel"
         :class="{ 'm--is-skin-light': lightSkin,
                   'm--is-skin-dark': darkSkin,
                   'm--is-skin-darker': darkerSkin,
                   'm--has-shadow': shadow,
                   'm--has-border': border,
                   'm--has-border-large': borderLarge,
                   'm--has-padding-large': paddingLarge,
                   'm--is-highlighted': highlighted}"
         @click="onClick">
    <header class="m-panel__header"
            :class="{ 'm--no-padding': !hasPaddingHeader,
                      'm--is-right-content-alone': !($slots.header || $slots['header-right-content']),
                      'm--has-menu': $slots.menu }"
            v-if="$slots.header || $slots['header-right-content']">
        <div class="m-panel__header__content"
             :aria-hidden="!($slots.header || $slots['header-right-content'])">
            <slot name="header"></slot>
        </div>
        <div class="m-panel__header__content-right"
             v-if="$slots['header-right-content']">
            <slot name="header-right-content"></slot>
        </div>
        <div class="m-panel__header__menu"
             v-if="$slots.menu">
            <slot name="menu"></slot>
        </div>
    </header>
    <div class="m-panel__body"
         :class="{ 'm--no-padding': !hasPaddingBody,
                   'm--has-padding-top': !$slots.header && hasPaddingBody,
                   'm--has-padding-bottom': hasPaddingBody }"
         v-if="$slots.default">
        <slot></slot>
    </div>
    <footer class="m-panel__footer"
            :class="{ 'm--no-padding': !hasPaddingFooter }"
            v-if="$slots.footer">
        <slot name="footer"></slot>
    </footer>
</article>
